module.exports = __webpack_public_path__ + "static/vins-40dc5bd7819100b158322c8654aeb732.jpg";